module.exports = __webpack_public_path__ + "img/rojo.c6da0059.png";